var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 66 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#152F5E;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h66L0,66V0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.6,31.1l2.3-2.3l6.7,3.1c0.9,0.4,1.8,0.9,2.6,1.4l0.1-0.1c-0.4-0.9-0.9-1.7-1.4-2.6l-3.2-6.5l2.3-2.3 l10.5,10.3L23.7,34l-4.4-4.3c-1-1-2.3-2.6-3.2-3.6l-0.1,0.1l1.6,3.3l2.8,5.9l-1.2,1.2l-6-2.7L10,32.1l-0.1,0.1 c1.1,0.9,2.7,2.1,3.7,3.1l4.4,4.3l-1.9,1.9L5.6,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.7,28.5c-1.5-1.4-1.4-3.2-1-4.9c-1.2-0.4-2.2-0.9-2.9-1.6c-1.5-1.4-1.6-3.7,0.1-5.3 c1.5-1.5,3.3-1.5,4.7-0.2c1.4,1.4,1.1,3.3,0.8,5.2c1.4,0.2,3,0.1,4.4-0.1c-0.2-1.3-0.6-2.6-1.4-3.9l1.9-1.9 c0.9,1.7,1.6,3.4,1.8,5.3c1.1-0.3,2-0.7,2.6-1.1l1.2,2.2c-1,0.6-2.3,1.2-3.7,1.5c-0.2,1.5-0.8,3-2.1,4.2 C27.9,30.2,25.3,30.1,23.7,28.5z M23.3,21.4c0.3-1.3,0.5-2.4-0.3-3.2c-0.5-0.5-1.1-0.7-1.7-0.1c-0.6,0.6-0.6,1.5,0.2,2.3 C21.9,20.8,22.5,21.1,23.3,21.4z M28.7,26.3c0.5-0.5,0.8-1.2,1-2c-1.6,0.2-3.3,0.1-4.8-0.1c-0.1,0.9,0,1.7,0.6,2.3 C26.4,27.3,27.7,27.2,28.7,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29,8.1l2.5-2.4l13.8,7l-2.2,2.2l-3.4-1.9l-3.4,3.3l2,3.4l-2.1,2.1L29,8.1z M35.1,14.2l2.5-2.5l-1.5-0.8 c-1.4-0.8-2.9-1.7-4.3-2.5l-0.1,0.1c0.9,1.4,1.8,2.9,2.5,4.2L35.1,14.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMA);
export default __webpack_public_path__ + "static/media/icon_m&A.5a10fbdf58cec1f57d10f80e3694ee36.svg";
export { ForwardRef as ReactComponent };